import { Breadcrumb, Card, Form, Layout, Menu, Modal, Row } from 'antd'
import AddQuestionnaireSystemCont from 'components/Main/QuestionnaireSystem/AddRating/AddQuestionnaireSystemCont'
import AddRatingSystemCont from 'components/Main/RatingSystem/AddRating/AddRatingSystemCont'
import MultiCurrency from 'elements/MultiCurrency'
import CurrencySelect from 'elements/Select/Currency'
import OrganisationsSelect from 'elements/Select/Organistaions'
import { GlobalContext } from 'Global'
import useFetchSelect from '../elements/Hooks/useFetchSelect'
import PageTitle from '../elements/PageTitle'
import PaymentModal from '../elements/Payment/PaymentModal'
import React, { Fragment, useState } from 'react'

const { Content } = Layout

function TestCont(props) {
  const [state, setState] = useState([])
  const lines = [
    { key: 1, title: '124', code: '124', amount: 500 },
    { key: 2, title: '124', code: '124', amount: 50 },
    { key: 3, title: '124', code: '124', amount: 5 },
  ]
  const { getFieldDecorator, setFieldsValue, resetFields, getFieldValue } = props.form

  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Product Management /</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Test Area'}
              subtitle={'This is a test Area.'}
              color={'#FF6138'}
              iconType={'shopping-cart'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card className="">
            <MultiCurrency
              doc={{}}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'vendorQuote',
                onChange: (e) => console.log(e),
              }}
            />

            <CurrencySelect style={{ width: '80%' }} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

export default Form.create()(TestCont)
